import * as React from "react";
import {assets} from "../../helpers";

export class PressConference2016 extends React.Component<any, any> {
    render() {
        return (
            <section className="press">
                <a name="press" />
                <h1>Пресса о LOUDHEAD 2016</h1>
                <ul>
                    <li>
                        <div className="media">
                            <div className="media-left"><a
                                href="http://djmag.ru/galleries/v-moskve-proshla-vystavka-loudhead-audio-show"
                                target="_blank"><img src={assets("press/djmag.png")} /></a></div>
                            <div className="media-body"><a
                                href="http://djmag.ru/galleries/v-moskve-proshla-vystavka-loudhead-audio-show"
                                target="_blank" className="pressName">DJMAG.RU</a><a
                                href="http://djmag.ru/galleries/v-moskve-proshla-vystavka-loudhead-audio-show"
                                target="_blank"><span>В Москве прошла выставка LOUDHEAD audio show!</span></a>
                                <p>
                                    В этом году шоу стало заметно больше, и вызвало большой интерес у публики.Павильон все два дня был наполнен людьми, активно и с удовольствием тестирующими наушники плееры и усилители.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a href="http://4pda.ru/2016/11/03/328446/"
                                                       target="_blank"><img src={assets("press/4pda.png")} /></a></div>
                            <div className="media-body"><a href="http://4pda.ru/2016/11/03/328446/"
                                                       target="_blank" className="pressName">4PDA.RU</a><a
                                href="http://4pda.ru/2016/11/03/328446/" target="_blank"><span>В Москве прошла аудио-выставка Loudhead 2016</span></a>
                                <p>
                                    Сотни посетителей выставки смогли одними из первых лично опробовать аудионовинки от именитых брендов, которые ещё даже не поступили в продажу.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a href="http://stereo.ru/news/loudhead-2016-results"
                                                       target="_blank"><img src={assets("press/stereo.png")} /></a></div>
                            <div className="media-body"><a href="http://stereo.ru/news/loudhead-2016-results"
                                                       target="_blank" className="pressName">STEREO.RU</a><a
                                href="http://stereo.ru/news/loudhead-2016-results" target="_blank"><span>Итоги Loudhead 2016: шотландская арматура, японская щедрость и всеобщая теплота</span></a>
                                <p>
                                    Розыгрышей на шоу было действительно немало: буквально каждые полчаса толпы людей собирались возле стендов, чтобы послушать о технологиях и инновациях, а после непременно разыгрывались ценные призы.
                                </p></div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a href="http://www.3dnews.ru/942061"
                                                       target="_blank"><img src={assets("press/3dnews.png")} /></a></div>
                            <div className="media-body"><a href="http://www.3dnews.ru/942061"
                                                       target="_blank" className="pressName">3DNEWS.RU</a><a
                                href="http://www.3dnews.ru/942061" target="_blank"><span>LOUDHEAD 2016: праздник качественного звука</span></a>
                                <p>
                                    Для одних данное мероприятие — это хорошая возможность попробовать на слух как уже зарекомендовавшие себя на рынке решения, так и ещё не поступившие в продажу новинки; для других — шанс продемонстрировать собственные системы, пообщаться с единомышленниками.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-left"><a
                                href="http://www.whathifi.com/ru/reportazh/vystavka-loudhead-2016-proshla-v-moskve"
                                target="_blank"><img src={assets("press/whathifi.png")} /></a></div>
                            <div className="media-body"><a
                                href="http://www.whathifi.com/ru/reportazh/vystavka-loudhead-2016-proshla-v-moskve"
                                target="_blank" className="pressName">WHATHIFI.COM</a><a
                                href="http://www.whathifi.com/ru/reportazh/vystavka-loudhead-2016-proshla-v-moskve"
                                target="_blank"><span>Выставка LOUDHEAD 2016 прошла в Москве</span></a>
                                <p>
                                    Самый большой праздник у российских любителей хорошего звука и аудиогаджетов случается в тот день года, когда открывает свои двери, пожалуй, наиболее масштабная выставка, посвященная персональному аудио – Loudhead Audio Show.
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Main/PressConference2016.tsx
 **/